<!--
    prpps:
        selectItems: 選択した item ※特殊(使用例から良い感じに読み取って)
        items: option のリスト（連想配列で指定する：これ以外は対応していないです）
        itemText: option の text に設定する連想配列のキー
        itemValue: option の value に設定する連想配列のキー
        label: ラベル（例：キャンペーン(複数選択可) ）
        required: 選択を必須とするか？（vFrom 仕様したとき、うまく作用するかは未確認）
        rules: （任意）入力値のチェックを実施したい場合に定義する

    使用例
    <MultiSelect
        v-bind:select-items.sync="creativeTypeIdsComputed"
        :items="creativeTypeList"
        item-text="creativeTypeName"
        item-value="creativeTypeId"
        label="クリエイティブ種別(複数選択可)"
        :required="false"
    />
    data:function () {
        return{
            creativeTypeIds: []
            creativeTypeList: [
                { creativeTypeId: 11, creativeTypeName: 'インバナー動画' }
            ]
        }
    },
    method: {
        hoge: function() {
            // creativeTypeIds を直接編集しないこと
            //※ 子に編集した内容が伝播しない（良い方法があれば教えてください）

            // Getter / Setter の使い方
            // 値を取得する
            this.creativeTypeIdsComputed
            // 値を設定する
            this.creativeTypeIdsComputed = []
        }
    },
    computed: {
        // 子と親の操作を連動 (sync) するようにしている
        creativeTypeIdsComputed: {
            get() {
                return this.creativeTypeIds
            },
            set(value) {
                this.creativeTypeIds = value
            }
        }
    }
-->
<template>
  <v-select
    v-model="selectItemsComputed"
    :items="items"
    :item-title="itemTitle"
    :item-value="itemValue"
    :label="label"
    :no-data-text="noDataText"
    :multiple="true"
    :rules="rules"
    ref ="multiSelector"
    :required="required"
  >
    <template v-slot:prepend-item>
      <v-list-item ripple @click="toggle">
        <template v-slot:prepend> <v-icon :color="selectItemsComputed.length > 0 ? 'indigo darken-4' : ''">{{
            isAllSelect ? 'mdi-close-box' : 'mdi-checkbox-blank-outline'
          }}</v-icon>
        </template>
        
        <v-list-item-title>{{ isAllSelect ? '選択を解除' : 'すべて選択' }}</v-list-item-title>
        
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
    
    <template v-slot:selection="{ item, index }">
      <span v-if="index === 0 && selectItemsComputed.length === 1" class="mt-item">
        {{ item.title }}
      </span>
      <span v-if="index === 1" class="mt-item">
        {{ selectItemsComputed.length }} 点選択
      </span>
    </template>
  </v-select>
</template>

<script>
export default {
  props: ['selectItems', 'items', 'itemTitle', 'itemValue', 'label', 'rules', 'required', 'noDataText'],
  data() {
    return {
      isAllSelect: false
    }
  },
  computed: {
    isSelectAll() {
      return this.selectItemsComputed.length === Object.keys(this.items).length
    },
    selectItemsComputed: {
      get() {
        return this.selectItems
      },
      set(value) {
        this.$emit('update:selectItems', value)
      }
    }
  },
  watch: {
    selectItems: function(selectItems) {
      if (this.isSelectAll) {
        this.isAllSelect = true
      } else {
        this.isAllSelect = false
      }
    }
  },
  methods: {
    toggle() {
      const key = this.itemValue
      this.$nextTick(() => {
        if (this.isSelectAll) {
          this.selectItemsComputed = []
        } else {
          let ids = []
          this.items.forEach(function(item) {
            ids.push(item[key])
          })
          this.selectItemsComputed = ids
        }
      })
    }
  }
}
</script>
<style scoped>
.mt-item {
  max-width: 100%;
  overflow:hidden;
}
</style>
